export const selectToast = (state) => state.application?.toast;
